import styled from "@emotion/styled";
import { GrEmpty, GrStack } from "@jnpmedi/grebob";
import { MvnMessage } from "@newLibs/utils";
import { DOCS_DOCUMENT_LANG } from "@maven-msg/lang/docs";
import { FolderFileType } from "@maven-rest/docs/FolderFile.dto";

interface InvalidAccessViewProps {
  accessType: FolderFileType;
}

export function InvalidAccessView({ accessType }: InvalidAccessViewProps) {
  const getTitle = () => {
    switch (accessType) {
      case FolderFileType.Document:
        return MvnMessage(DOCS_DOCUMENT_LANG.DOCUMENT_FOLDER_INVALID_ACCESS);
      case FolderFileType.Sign:
        return MvnMessage(DOCS_DOCUMENT_LANG.DOCUMENT_CANCELED_SIGN);
      default:
        throw Error("Invalid Argument");
    }
  };

  const getDescription = () => {
    switch (accessType) {
      case FolderFileType.Document:
        return MvnMessage(DOCS_DOCUMENT_LANG.DOCUMENT_FOLDER_INVALID_ACCESS_DESCRIPTION);
      case FolderFileType.Sign:
        return MvnMessage(DOCS_DOCUMENT_LANG.DOCUMENT_CANCELED_SIGN_DESCRIPTION);
      default:
        throw Error("Invalid Argument");
    }
  };

  return (
    <GrStack minHeight={400} height="85vh" flexDirection="column" alignItems="center" justifyContent="center" padding={"24px, 8px"}>
      <StyledEmpty type="notFound" title={getTitle()} description={getDescription()} />
    </GrStack>
  );
}

const StyledEmpty = styled(GrEmpty)(() => ({
  "> *": {
    wordBreak: "break-word",
    whiteSpace: "pre-wrap",
    textAlign: "center",
    lineHeight: 1.6,
  },
}));
